import React, {lazy, memo, Suspense, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Loading from 'components/shared-components/Loading';
import Views from 'views';
import {API, RootState} from "store";

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
  const dispatch = useDispatch();
  const {auth_token} = useSelector((state: RootState) => state.auth);
  const blankLayout = useSelector((state: RootState) => state.theme.blankLayout);
  const direction = useSelector((state: RootState) => state.theme.direction);
  const navType = useSelector((state: RootState) => state.theme.navType);
  const navCollapsed = useSelector((state: RootState) => state.theme.navCollapsed);
  const Layout = auth_token && !blankLayout ? AppLayout : AuthLayout

  useEffect(() => {
    if ( auth_token ) dispatch(API.profile.item());
  }, [dispatch, auth_token]);

  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Layout direction={direction} navType={navType} navCollapsed={navCollapsed}>
        <Views/>
      </Layout>
    </Suspense>
  )
}

export default memo(Layouts);